import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function NinetyDayPlanPage() {
  const [weeks1to4, setWeeks1to4] = useState('');
  const [weeks5to8, setWeeks5to8] = useState('');
  const [weeks9to12, setWeeks9to12] = useState('');
  const [weeklyReview, setWeeklyReview] = useState('');
  const [monthlyRetro, setMonthlyRetro] = useState('');
  const [stakeholderSync, setStakeholderSync] = useState('');
  const [emergingBets, setEmergingBets] = useState('');
  const [assumptionsToTest, setAssumptionsToTest] = useState('');

  return (
    <TaskPage
      phase="prioritize"
      title="90-day Plan"
      pageNumber={6}
      instruction="Zoom out, still light. Place Now slices first 2-4 weeks; Next in weeks 5-8; milestones for 9-12 only if confidence is Medium/High."
      whyItMatters="Spacing and regular retrieval strengthen retention and habit formation around prioritization."
      coachRail={{
        timing: "15 minutes",
        tips: "Keep it light. Focus on Now slices first, then Next. Only add 9-12 if confident.",
        debrief: "Is the plan realistic? Do we have review cadence set?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Quarter Strip (Weeks 1-12)</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Weeks 1-4 (Now slices)</label>
              <TextArea
                value={weeks1to4}
                onChange={(e) => setWeeks1to4(e.target.value)}
                placeholder="Place Now slices here - what will we do in the first 2-4 weeks?"
                rows={4}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Weeks 5-8 (Next queue)</label>
              <TextArea
                value={weeks5to8}
                onChange={(e) => setWeeks5to8(e.target.value)}
                placeholder="Place Next items here - what comes after Now?"
                rows={4}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--text-sec)] mb-2">Weeks 9-12 (Only if Medium/High confidence)</label>
              <TextArea
                value={weeks9to12}
                onChange={(e) => setWeeks9to12(e.target.value)}
                placeholder="Milestones only if confidence is Medium/High"
                rows={4}
              />
            </div>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Review Cadence</h3>
          <div className="space-y-4">
            <TextInput
              label="Weekly 15-min priority review (keep/kill/slice)"
              value={weeklyReview}
              onChange={(e) => setWeeklyReview(e.target.value)}
              placeholder="e.g., Every Monday 9am"
            />
            <TextInput
              label="Monthly retro vs criteria (did our rules help?)"
              value={monthlyRetro}
              onChange={(e) => setMonthlyRetro(e.target.value)}
              placeholder="e.g., First Friday of month"
            />
            <TextInput
              label="Stakeholder sync rhythm"
              value={stakeholderSync}
              onChange={(e) => setStakeholderSync(e.target.value)}
              placeholder="e.g., Bi-weekly on Thursdays"
            />
          </div>
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Space for Notes</h3>
          <TextArea
            label="Emerging bets for next cycle"
            value={emergingBets}
            onChange={(e) => setEmergingBets(e.target.value)}
            placeholder="What new opportunities are emerging?"
            rows={3}
          />
          <TextArea
            label="Assumptions to test"
            value={assumptionsToTest}
            onChange={(e) => setAssumptionsToTest(e.target.value)}
            placeholder="What assumptions need validation?"
            rows={3}
            className="mt-4"
          />
        </div>

        <Callout type="tip" phase="prioritize">
          <p className="text-sm">Keep the plan light and flexible. Focus on Now slices first. Only add future milestones if confidence is Medium/High.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






